import { Tooltip as TooltipComponent } from '@telus-uds/components-web'

export interface TooltipProps {
  entryTitle?: string
  tooltipContent: string
  tooltipTextTrigger?: string
  tooltipPosition?: 'auto' | 'above' | 'right' | 'below' | 'left'
  tooltipActiveOnHover?: boolean
  tooltipInline?: boolean
}

const Tooltip = ({
  tooltipContent,
  tooltipTextTrigger,
  tooltipPosition,
  tooltipActiveOnHover,
  tooltipInline = true,
}: TooltipProps) => {
  return (
    <TooltipComponent
      testID="tooltip"
      content={tooltipContent}
      position={tooltipPosition}
      inline={tooltipInline}
      activateOnHover={tooltipActiveOnHover}
    >
      {tooltipTextTrigger ? <>{tooltipTextTrigger}</> : undefined}
    </TooltipComponent>
  )
}

export default Tooltip
